import { arrayToObject } from '@/@core/utils/utils'

export const TRIP_TYPE_OPTIONS = [
  // D hoặc A (D: chuyến bay đi, A: chuyến bay đến)
  { label: 'Departure', value: 'D' },
  { label: 'Arrival', value: 'A' },
]

export const TRIP_TYPE = arrayToObject(TRIP_TYPE_OPTIONS, 'label', 'value')

export const DEPARTURE_HOUR_OPTIONS = [
  { label: 'ALL', value: null },
  { label: '00:00 - 04:00', value: '0 | 4' },
  { label: '04:00 - 08:00', value: '4 | 8' },
  { label: '08:00 - 12:00', value: '8 | 12' },
  { label: '12:00 - 16:00', value: '12 | 16' },
  { label: '16:00 - 20:00', value: '16 | 20' },
  { label: '20:00 - 00:00', value: '20 | 24' },
]

export const tableColumns = [
  { label: 'scheduleTime', key: 'scheduleTime', isHideMobile: true },
  { label: 'estimateTime', key: 'estimateTime' },
  { label: 'airportName', key: 'airportName', isHideMobile: true },
  { label: 'airlineName', key: 'airlineName', isHideMobile: true },
  { label: 'flightNumber', key: 'flightNumber' },
  { label: 'terminal', key: 'terminal', isHideMobile: true },
  { label: 'checkinRow', key: 'checkinRow', isHideMobile: true },
  { label: 'gate', key: 'gate', isHideMobile: true },
  { label: 'remark', key: 'remark' },
  { label: 'action', key: 'action', isOnlyShowMobile: true },
]
